


























import { Component, Prop, Vue } from "vue-property-decorator";
import IconClose from "@/components/icons/IconClose.vue";
@Component({
  components: { IconClose },
})
export default class FilterLink extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: String, default: "" })
  readonly label!: string;

  @Prop({ type: String, default: null })
  readonly code!: string;

  get isActive(): boolean {
    return this.$route.query[this.code] === "true";
  }

  action() {
    const query = { ...this.$route.query };

    if (this.isActive) {
      delete query[this.code];
    } else {
      query[this.code] = "true";
    }

    this.$router.push({ query: query });
  }
}
